import React from 'react';
import './ImageCard.scss';

const ImageCard = ({ src, alt = '', caption }) => {
    return (
        <figure className="image-card">
            <img src={src} alt={alt} />
            {caption && <figcaption className="image-card__caption">{caption}</figcaption>}
        </figure>
    );
};

export default ImageCard;
